import { BaseModel } from './base.model'
import { Vehicle } from './vehicle.model'
import { Team } from './team.model'

export class VehicleGroup extends BaseModel {
  id: string
  name: string
  vehicles: Vehicle[]
  clientId: number
  team: Team
  vehiclesCount: number
  color: string
}

export type VehicleGroupInList = Pick<VehicleGroup, 'id' | 'name'>
